import React from 'react';
import {Props as TextInputProps} from './text-input';
import {phoneRegex} from 'src/utils/validations';
import placeholders from 'src/static/placeholders.json';
import {SpecificInputProps} from './utils';

import FormikTextInput from 'src/components/inputs/formik-text-input';

/**
 *
 * @requires Yup.string().phoneNumber()
 *
 */
const FormikTelInput = ({...props}: TextInputProps & SpecificInputProps) => (
  <FormikTextInput
    {...props}
    pattern={phoneRegex.source}
    type="tel"
    placeholder={placeholders.tel}
  />
);

export default FormikTelInput;
